import { createAsyncThunk } from '@reduxjs/toolkit';
import { RegionsApi } from '../http';

const regionsApi = new RegionsApi();

export const fetchRegionsDelete = createAsyncThunk(
  'regions/delete',
  async (id: string, { rejectWithValue }) => {
    try {
      return await regionsApi.removeOne({ id });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
